import React, { useState, useEffect, useContext } from 'react';
import { coreAxios } from "utilities/axios";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { MasterButton } from "components/Buttons/MasterButton";
import  DeleteModalTwo  from "components/Modal/DeleteModalTwo";
import AuthContext from  "../../context/AuthContext";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { UpdateSale} from 'services/sale/sale.service';
import { GetInvoices, GetSaleDetail, DeleteSaleItem } from 'services/saleDetails/saleDetails.service';
import { TableDetailInvoice } from 'components/Table/TableDetailInvoice';
import { Table } from 'components/Table/Table';
import { RequisitionTableForm } from 'components/Table/RequisitionTableForm';
import { NameColumn, TextColumn } from 'components/Table/ColumnTemplates/CustomColumn';
import { RequisitionValidationSchema } from 'utilities/ValidationSchema/Requisition/RequisitionValidationSchema';
import useProductDataTable from './hook/useProductDataTable';
const BASE_URL = process.env.REACT_APP_MAIN_URL


const ReturnFromEmployee = () => {
    const {invoiceList, invoiceListLoading} = useSelector((state) => state.invoiceList);
    const {saleDetail, saleDetailLoading} = useSelector((state) => state.saleDetail);
    const {saleUpdate, saleUpdateLoading} = useSelector((state) => state.saleUpdate);
    const [deleteProductID, setDeleteProductID] = useState();
    const [showDeleteProductModal, setShowDeleteProductModal] = useState(false);
    const [showForm, setShowForm] = useState(false); //* state for form modal
    const [showDetail, setShowDetail] = useState(false); //* state for form modal
    const [updateData, setUpdateData] = useState(null); // * state for update data
    const {user} = useContext(AuthContext);


    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        total_price: "",
        sale_items: [
            {
                id: 0,
                stock_name: "",
                stock_uom: "",
                rate: "",
                quantity: "",
                total_price_per_item: "",
            },
        ],
    };

    const updateInitialValue = {
        id: updateData?.id,
        total_price: updateData?.total_price,
        invoice_no: updateData?.invoice_no,
        sale_items: saleDetail?.map((value) => {
            return {
                ...value,

            };
        }) || [
            {
                id: 0,
                stock_name: "",
                stock_uom: "",
                rate: "",
                quantity: "",
                total_price_per_item: "",
            },
        ],

    };

    const formik = useFormik({
        initialValues: updateData ? updateInitialValue : createInitialValue, // * if state is update then updateData state value will show up
        // validationSchema: RequisitionValidationSchema, // * yup schema validation
        onSubmit: (values) => {

            const modifiedData = {
                ...values,
                sale_items: values.sale_items.map((value) => {
                    return{
                        ...value,
                        total_price_per_item: parseFloat((parseFloat(value.rate) * value.quantity).toFixed(3))
                    }
                })
            };
            handelSubmit(modifiedData);
        },
        enableReinitialize: true,
    });

    const { modalTableColumns, modalTableActionButton } = useProductDataTable(
        formik, 
        setDeleteProductID, 
        setShowDeleteProductModal, 
        setShowForm, 
        setUpdateData,
    );


    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();


    const updateInvoice = (invoice) => {
        setShowForm(true); // * set the form to true
        dispatch(GetSaleDetail(invoice?.id))
        setUpdateData(invoice);
    };

    const saleDetails = (invoice) => {
        setShowDetail(true); // * set the form to true
        dispatch(GetSaleDetail(invoice?.id))
    };


    // delete 1

    const confirmDeleteProductDetail = async () => {
        const { id, invoice } = deleteProductID;
        await dispatch(DeleteSaleItem(id));
        setShowDeleteProductModal(false);
        await dispatch(GetSaleDetail(invoice));
    };

    // form submit handler
    const handelSubmit = async (data) => {
        let total_price = 0

        for(let i=0; i< data.sale_items.length; i = i+1){
            if(typeof data.sale_items[i]['quantity'] !== 'undefined'){
                if(data.sale_items[i]['quantity'] !== 0){
                    total_price = total_price + data.sale_items[i]['total_price_per_item']
                }
            }
        }

        const modifiedData = {
            ...data,
            total_price: parseFloat(total_price).toFixed(3)
        }

        if(updateData){
            await dispatch(UpdateSale(modifiedData)).then(() => {
                downloadInvoice(modifiedData)
                hideModal();
            });
            return
        }
    };
    


    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
        setShowForm(false); // * close the form
        setShowDetail(false);
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    useEffect(() => {
        dispatch(GetInvoices(user?.shop_id));
    }, [saleUpdate, saleDetail]);


    // columns of the table with header name
    const tableColumns = [
        { field: "invoice_no", header: "Invoice No", sortableBody: TextColumn },
        { field: "emp_code", header: "Employee Code", sortableBody: TextColumn },
        { field: "date", header: "Date", sortableBody: TextColumn },
        { field: "total_price", header: "Total price", sortableBody: TextColumn },
    ];

    const detailTableColumns = [
        { field: "stock_name", header: "Item", sortableBody: NameColumn },
        { field: "stock_code", header: "Item Code", sortableBody: NameColumn },
        { field: "stock_uom", header: "Item Uom", sortableBody: NameColumn },
        { field: "rate", header: "Rate", sortableBody: TextColumn },
        { field: "quantity", header: "Quantity", sortableBody: TextColumn },
        { field: "total_price_per_item", header: "Price", sortableBody: TextColumn },
    ];

    const downloadInvoice = async (data) => {
 
        const url = `${BASE_URL}/api/invoice/download/${data.id}/`;
        try {
            const response = await coreAxios.get(url, {
                responseType: 'blob',
            });
            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `invoice-${data.invoice_no}.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch(error){
            console.log(error)
        }
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    <Button 
                        icon="pi pi-sort-alt" 
                        className="p-button-rounded p-button-success mr-2" 
                        onClick={() => updateInvoice(rowData)} 
                    />
                    <Button 
                        icon="pi pi-list" 
                        className="p-button-outlined p-button-info mr-2" 
                        onClick={(e) => {
                            saleDetails(rowData)
                        }}
                    />
                    <Button 
                        icon="pi pi-download" 
                        className="p-button-outlined p-button-info mr-2" 
                        onClick={(e) => {
                            downloadInvoice(rowData)
                        }}
                    />
                </div>
            </>
        );
    }

    return (
        <>
            <Table
                tableHeaderName="Return Invoice Details"
                tableColumns={tableColumns}
                data={invoiceList}
                loading={invoiceListLoading}
                dataKey="id"
                rows={25}
                sortable
                exportBtn
                searchField
                isRowSelectable
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                actionButton={actionBodyTemplate}
                // setShowCreateModal={setShowForm}
                hideLeftToolbar={true}
            />
            <Dialog 
                visible={showForm} 
                style={{ width: "1400px" }} 
                header={`${updateData ? "Update" : "Create"} Invoice`} 
                className="p-fluid" 
                onHide={hideModal} 
                modal closeOnEscape blockScroll icons focusOnShow resizable maximizable
            >
                <form onSubmit={formik.handleSubmit} className={`grid grid-cols-4 mt-2 gap-x-3`}>

                    <div className="col-12">
                        <div className="w-full">
                            <RequisitionTableForm
                                emptyMessage="No data found"
                                tableColumns={modalTableColumns}
                                data={formik.values.sale_items}
                                loading={invoiceListLoading}
                                dataKey="productID"
                                actionButtonWidth={10}
                                actionButton={modalTableActionButton}
                            />
                        </div>
                    </div>
                    
                    <MasterButton resetForm={resetForm} update={updateData} loading={invoiceListLoading} col1={8} col2={updateData ? 6 : 7} col3={4}/>
                    <DeleteModalTwo
                        visibleModal={showDeleteProductModal}
                        header="Confirm"
                        onHide={() => setShowDeleteProductModal(false)}
                        multiItem={false}
                        confirmDelete={confirmDeleteProductDetail}
                        item={deleteProductID}
                        loading={saleDetailLoading}
                        message="Are you sure you want to delete this item? This Cannot be undone!"
                    />
                </form>
            </Dialog>

            <Dialog 
                visible={showDetail} 
                style={{ width: "1400px" }} 
                // header="Chalan Details"
                className="p-fluid" 
                onHide={hideModal} 
                position="top"
                modal closeOnEscape blockScroll icons focusOnShow resizable maximizable
            >
                
                <Divider align="center">
                    <span className="p-tag">Sale Items Details</span>
                </Divider>

                <TableDetailInvoice
                    tableColumns={detailTableColumns}
                    data={saleDetail}
                    loading={saleDetailLoading}
                    dataKey="id"
                />
            </Dialog>
        </>
    );
};

export default ReturnFromEmployee;
